var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Steps", { attrs: { "current-page": 4 } }),
      _c("div", { staticClass: "text-center heading-wrapper" }, [
        _c("span", { staticClass: "heading" }, [
          _vm._v(_vm._s(_vm.$t("choose_profile"))),
        ]),
      ]),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "container container-xs" },
            [
              _c("div", { staticClass: "purchase-wrapper" }, [
                _c("div", { staticClass: "text-center" }, [
                  _c("span", { staticClass: "main-text" }, [
                    _vm._v(_vm._s(_vm.$t("order_step4"))),
                  ]),
                ]),
              ]),
              !_vm.isLoggedIn
                ? [
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "p",
                        { staticClass: "p-first-login" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "main-link",
                              attrs: {
                                to: {
                                  name: "login",
                                  params: { from: "billing" },
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("login_to_your_account")) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("login_to_your_account_2")) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center text-center",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c("div", { staticClass: "circle" }, [
                          _c("p", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.$t("or"))),
                          ]),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "text-center mb-5 mb-md-0" }, [
                      _c("p", { staticClass: "p-first-login" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("order_without_account")) + " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "container-billing" },
                      [
                        _vm.showWarningMessageStatus
                          ? _c(
                              "div",
                              {
                                ref: "warningMessage",
                                staticClass: "alert alert-danger text-center",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("fill_all_fields")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "input-text",
                              attrs: { for: "email" },
                            },
                            [_vm._v(_vm._s(_vm.$t("label_email")) + "*")]
                          ),
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _vm._v(" " + _vm._s(_vm.errorMsgs.email) + " "),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profileData.email,
                                expression: "profileData.email",
                              },
                            ],
                            staticClass: "form-control p-4 mb-3",
                            class: { "has-error": _vm.errorMsgs.email },
                            attrs: {
                              dusk: "email-address",
                              id: "email",
                              type: "text",
                            },
                            domProps: { value: _vm.profileData.email },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profileData,
                                    "email",
                                    $event.target.value
                                  )
                                },
                                _vm.validate,
                              ],
                            },
                          }),
                          _c("div", { staticClass: "d-flex mb-4" }, [
                            _c("div", {
                              staticClass: "icon warning-icon mr-2",
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("order_address_info"))),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "input-text",
                              attrs: { for: "phone" },
                            },
                            [_vm._v(_vm._s(_vm.$t("label_phone")) + "*")]
                          ),
                          _c("span", { staticClass: "invalid-feedback" }, [
                            _vm._v(" " + _vm._s(_vm.errorMsgs.phone) + " "),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.profileData.phone,
                                expression: "profileData.phone",
                              },
                            ],
                            staticClass: "form-control p-4",
                            class: { "has-error": _vm.errorMsgs.phone },
                            attrs: { id: "phone", type: "tel" },
                            domProps: { value: _vm.profileData.phone },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.profileData,
                                    "phone",
                                    $event.target.value
                                  )
                                },
                                _vm.validate,
                              ],
                            },
                          }),
                        ]),
                        _c("BillingProfile", {
                          attrs: { errorMsgs: _vm.errorMsgs },
                          on: {
                            verifiedStatus: _vm.setVerifiedStatus,
                            resetErrors: _vm.resetErrorMsgs,
                            input: _vm.updateProfileFromComponent,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.isLoggedIn
                ? [
                    _vm.profiles
                      ? _c(
                          "div",
                          { staticClass: "profiles" },
                          _vm._l(_vm.profiles, function (profile) {
                            return _c(
                              "div",
                              {
                                key: profile.id,
                                staticClass: "profile",
                                class: {
                                  danger: !_vm.isValidatedProfile(profile),
                                  active:
                                    _vm.orderDetails.profile_id == profile.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.doSetDefaultProfile(profile)
                                  },
                                },
                              },
                              [
                                _c("Profile", { attrs: { profile: profile } }),
                                _vm.orderDetails.profile_id == profile.id
                                  ? _c("div", { staticClass: "bullet" }, [
                                      _c("span", {
                                        staticClass: "icon v-icon",
                                      }),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "profile-actions" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "icon-wrapper edit",
                                        attrs: {
                                          to: {
                                            name: "edit-profile",
                                            params: { id: profile.id },
                                          },
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "icon edit-icon",
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "delete icon-wrapper",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteProfileAsk(
                                              profile.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "icon delete-icon",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-md-end" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "add-profile main-btn",
                            attrs: { to: { name: "add-profile" } },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("billing_add_new_profile")) +
                                " "
                            ),
                            _c("span", { staticClass: "icon icon-plus" }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c("BillingButtons", {
                attrs: {
                  hasCompletedBillingFields: _vm.valid,
                  orderDetails: _vm.orderDetails,
                },
                on: {
                  nextStepAttempt: function ($event) {
                    return _vm.showWarningMessage()
                  },
                },
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }